export interface SliderFieldDef {
  type: 'slider'
  id: string
  label: string
  group: string
  min: number
  max: number
  step: number
  unit?: string
  defaultValue: number
}

export interface SelectFieldDef {
  type: 'select'
  id: string
  label: string
  group: string
  options: { label: string; value: string }[]
  defaultValue: string
}

export interface ToggleFieldDef {
  type: 'toggle'
  id: string
  label: string
  group: string
  defaultValue: boolean
}

export interface ColorFieldDef {
  type: 'color'
  id: string
  label: string
  group: string
  defaultValue: string
}

export interface TextFieldDef {
  type: 'text'
  id: string
  label: string
  group: string
  defaultValue: string
}

export type FieldDef =
  | SliderFieldDef
  | SelectFieldDef
  | ToggleFieldDef
  | ColorFieldDef
  | TextFieldDef

export type FieldValues = Record<string, any>

export function getDefaultValues(fields: FieldDef[]): FieldValues {
  const values: FieldValues = {}
  for (const field of fields) {
    values[field.id] = field.defaultValue
  }
  return values
}

export function getFieldGroups(fields: FieldDef[]): string[] {
  const seen = new Set<string>()
  const groups: string[] = []
  for (const field of fields) {
    if (!seen.has(field.group)) {
      seen.add(field.group)
      groups.push(field.group)
    }
  }
  return groups
}

export function getFieldsByGroup(fields: FieldDef[], group: string): FieldDef[] {
  return fields.filter((f) => f.group === group)
}
